var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAudioRecording(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,53.95215a10.66985,10.66985,0,0,0,10.75-10.563V19.81348a10.75165,10.75165,0,0,0-21.5,0V43.38916A10.66985,10.66985,0,0,0,40,53.95215ZM30.75,19.81348A9.25173,9.25173,0,0,1,49.221,19.25H44v1.5h5.25v4.5H44v1.5h5.25v4.5H44v1.5h5.25V43.38916a9.25193,9.25193,0,0,1-18.5,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.75,43.03125V38h-1.5v5.03125C53.25,50.87158,47.30566,57.25,40,57.25S26.75,50.87158,26.75,43.03125V38h-1.5v5.03125c0,8.39771,6.21655,15.25806,14,15.67828V69.25h-10v1.5h21.5v-1.5h-10V58.70953C48.53345,58.28931,54.75,51.429,54.75,43.03125Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudioRecording);
export default __webpack_public_path__ + "static/media/icon_audio_recording.f02a929066c9e017d24da9961184b73e.svg";
export { ForwardRef as ReactComponent };